import { Logo } from "@/components/Navbar";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#09090b] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Logo dark />
            <p className="text-sm text-white/50 mt-4 max-w-xs font-body">Turn your Google Maps listing into a professional website in minutes.</p>
          </div>
          <div>
            <div className="ml-label mb-4">Product</div>
            <ul className="space-y-3 text-sm text-white/60 font-body">
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><a href="/#features" className="hover:text-white">Features</a></li>
              <li><a href="/#how" className="hover:text-white">How it works</a></li>
            </ul>
          </div>
          <div>
            <div className="ml-label mb-4">Company</div>
            <ul className="space-y-3 text-sm text-white/60 font-body">
              <li><span className="hover:text-white">About</span></li>
              <li><span className="hover:text-white">Blog</span></li>
              <li><span className="hover:text-white">Careers</span></li>
            </ul>
          </div>
          <div>
            <div className="ml-label mb-4">Legal</div>
            <ul className="space-y-3 text-sm text-white/60 font-body">
              <li><span className="hover:text-white">Privacy</span></li>
              <li><span className="hover:text-white">Terms</span></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-12 pt-8 text-sm text-white/40 font-body">© {new Date().getFullYear()} MapLift. All rights reserved.</div>
      </div>
    </footer>
  );
}
